// เงาบอก "ตารางยังมีต่อทางขวา" สำหรับกล่อง .scroll-hint-x (ดู landing.scss)
// ซ่อนเงาเมื่อ (ก) เนื้อหาไม่ล้นจริง หรือ (ข) เลื่อนไปสุดขวาแล้ว — ไม่งั้นเงาค้างหลอกตา
function syncHint(box) {
  var overflowing = box.scrollWidth - box.clientWidth > 4;
  var atEnd = box.scrollLeft + box.clientWidth >= box.scrollWidth - 4;
  box.toggleAttribute("data-scroll-end", !overflowing || atEnd);
}

function initScrollHints() {
  document.querySelectorAll(".scroll-hint-x").forEach(function (box) {
    syncHint(box);
    if (box.dataset.scrollHintBound) return;
    box.dataset.scrollHintBound = "1";
    box.addEventListener("scroll", function () { syncHint(box); }, { passive: true });
  });
}

document.addEventListener("turbo:load", initScrollHints);
window.addEventListener("resize", initScrollHints);
if (document.readyState !== "loading") initScrollHints();
else document.addEventListener("DOMContentLoaded", initScrollHints);
